export enum headerClass {
  H1='h1',
  H2='h2',
  H3='h3',
  H4='h4',
  H5='h5',
  H6='h6',
  H7='h7',
  H8='h8',
  H9='h9',
  BODY1='body-1-medium',
  BODY2='body-2-medium',
  BODY3='body-3-medium',
}

export enum headerType {
  H1='h1',
  H2='h2',
  H3='h3',
  H4='h4',
  H5='h5',
  H6='h6',
  H7='h7',
}

export enum photoSide {
  LEFT='left',
  RIGHT='right',
}

export enum photoPosition {
  LEFT='left',
  RIGHT='right',
  CENTER='center',
}
